/**
 * defa.views.UserNewPasswordForm
 * A view for creating a new password.
 * @version 1.2.0
 */
import { defa } from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/userNewPasswordForm.jst.html'

const api                 = {
	pass: defa.vars.apiHost + '/resetpassword?token=%s'
};
const selectors           = {
	inputPasswordOne: '[data-input="new-password-one"]',
	inputPasswordTwo: '[data-input="new-password-two"]',
};
const UserNewPasswordForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template        : template,
	noInitValidation: true,
	
	ui: {
		password1: selectors.inputPasswordOne,
		password2: selectors.inputPasswordTwo,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Validates the form.
	 * @return {bool}  True if both password fields are alike, false if not.
	 */
	validate: function () {
		return ( this.ui.password1.val().trim() === this.ui.password2.val().trim() );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		
		let self      = this,
			password1 = this.ui.password1.val().trim(),
			password2 = this.ui.password2.val().trim();
		
		let redirectUrl = self.getQueryValue( 'redirect' );
		let internalPath = self.getQueryValue('internalpath');
		
		
		if ( password1 === password2 ) {
			$.ajax( {
				 url        : api.pass.replace( '%s', self.options.token ),
				 method     : 'POST',
				 contentType: 'application/json',
				 data       : JSON.stringify( {
					 newPassword: password1
				 } ),
			 } )
			 .done( function ( /* response */ ) {
					if ( redirectUrl ) {
						self.trigger( 'password:redirect', redirectUrl );
					} else if (internalPath) {
						self.trigger( 'password:internal', internalPath );
					} else {
						self.trigger( 'password:created' );
					}
			 } )
			 .fail( function ( response ) {
				 self.outputFeedback( {
					 response: response,
					 status  : 'error',
				 } );
			 } );
		}
	},
	
} );

export default UserNewPasswordForm;
